import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface ErrorState {
    message: string | null;
    type: "error" | "success" | "info" | "warning" | null;
}

const initialState: ErrorState = {
    message: null,
    type: null,
};

const errorSlice = createSlice({
    name: "error",
    initialState,
    reducers: {
        setError(state, action: PayloadAction<{ message: string; type?: ErrorState["type"] }>) {
            state.message = action.payload.message;
            state.type = action.payload.type || "error";
        },
        clearError(state) {
            state.message = null;
            state.type = null;
        },
    },
});

export const { setError, clearError } = errorSlice.actions;
export default errorSlice.reducer;
